import { TOURNAMENT_TOAST_MINUTES } from "./types";
import { formatTournamentCountdown, msUntil } from "./countdown";
import type { TournamentSummary } from "./types";

const shownKeys = new Set<string>();

function toastKey(tournamentId: string, minutes: number) {
  return `${tournamentId}:${minutes}`;
}

let toastRoot: HTMLElement | null = null;

function ensureRoot(): HTMLElement {
  if (!toastRoot) {
    toastRoot = document.createElement("div");
    toastRoot.id = "tournamentToastStack";
    toastRoot.className = "tournamentToastStack";
    document.body.appendChild(toastRoot);
  }
  return toastRoot;
}

export function pushTournamentStartToast(
  tournament: Pick<TournamentSummary, "id" | "name" | "startsAt">,
  minutesLeft: number,
  serverNow: string,
) {
  const key = toastKey(tournament.id, minutesLeft);
  if (shownKeys.has(key)) return;
  shownKeys.add(key);

  const root = ensureRoot();
  const el = document.createElement("div");
  el.className = "tournamentToast";
  const title = document.createElement("p");
  title.className = "tournamentToastTitle";
  title.textContent = `"${tournament.name}" starts soon`;
  const body = document.createElement("p");
  body.className = "tournamentToastBody";
  const update = () => {
    const left = msUntil(tournament.startsAt, new Date().toISOString());
    body.textContent = `Starting in ${formatTournamentCountdown(left)}`;
  };
  update();
  const timer = window.setInterval(update, 1000);
  el.append(title, body);
  root.appendChild(el);
  requestAnimationFrame(() => el.classList.add("tournamentToast--show"));
  window.setTimeout(() => {
    clearInterval(timer);
    el.classList.remove("tournamentToast--show");
    window.setTimeout(() => el.remove(), 400);
  }, 120000);
}

export function tickTournamentToasts(
  registeredUpcoming: TournamentSummary[],
  serverNow: string,
) {
  for (const t of registeredUpcoming) {
    if (!t.registered) continue;
    const ms = msUntil(t.startsAt, serverNow);
    for (const min of TOURNAMENT_TOAST_MINUTES) {
      const target = min * 60 * 1000;
      const windowMs = 45000;
      if (ms <= target && ms > target - windowMs) {
        pushTournamentStartToast(t, min, serverNow);
      }
    }
  }
}

export function clearTournamentToasts() {
  toastRoot?.replaceChildren();
}
